// Easing functions as arrays (for use with animation libraries that accept [x1, y1, x2, y2])
// Usage: import { easeOutQuad, easeInQuad, ... } from './easing';

export const easeInQuad = [0.11, 0, 0.5, 0];
export const easeOutQuad = [0.5, 1, 0.89, 1];
export const easeInOutQuad = [0.45, 0, 0.55, 1];

export const easeInQuart = [0.5, 0, 0.75, 0];
export const easeOutQuart = [0.25, 1, 0.5, 1];
export const easeInOutQuart = [0.76, 0, 0.24, 1];

export const easeInQuint = [0.64, 0, 0.78, 0];
export const easeOutQuint = [0.22, 1, 0.36, 1];
export const easeInOutQuint = [0.83, 0, 0.17, 1];

export const easeInCubic = [0.32, 0, 0.67, 0];
export const easeOutCubic = [0.33, 1, 0.68, 1];
export const easeInOutCubic = [0.65, 0, 0.35, 1];

export const easeInBack = [0.36, 0, 0.66, -0.56];
export const easeOutBack = [0.34, 1.56, 0.64, 1];
export const easeInOutBack = [0.68, -0.6, 0.32, 1.6];

export const easeInCirc = [0.55, 0, 1, 0.45];
export const easeOutCirc = [0, 0.55, 0.45, 1];
export const easeInOutCirc = [0.85, 0, 0.15, 1];

export const easeInExpo = [0.7, 0, 0.84, 0];
export const easeOutExpo = [0.16, 1, 0.3, 1];
export const easeInOutExpo = [0.87, 0, 0.13, 1];

export const easeInSine = [0.12, 0, 0.39, 0];
export const easeOutSine = [0.61, 1, 0.88, 1];
export const easeInOutSine = [0.37, 0, 0.63, 1];

export const easeOutMaterial = [0, 0, 0.2, 1];
export const easeInMaterial = [0.4, 0, 1, 1];
export const easeInOutMaterial = [0.4, 0, 0.2, 1];
export const authenticMotion = easeInOutMaterial;

export const easeDefault = [0.5, 1, 0.89, 1];
